module.exports = __webpack_public_path__ + "static/media/yinger.304831ff.png";